<template>
  <b-modal
    ref="mdpm_kompack"
    dialog-class="!w-full !max-w-[600px]"
    body-class="!p-0"
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    hide-header
  >
    <div
      class="relative p-[20px] pb-0"
    >
      <div class="flex items-center justify-between gap-[8px] mb-[24px] mx-[16px]">
        <div class="flex items-center justify-start gap-[8px] flex-wrap">
          <h3 class="text-[#333333] text-[18px] font-semibold text-center mb-0">
            Detail Perubahan
          </h3>
          <span
            class="rounded-full py-[4px] px-[12px] border-solid border-[1px] inline-block text-[12px] font-medium"
            :class="statusPengajuan.css"
          >
            {{ statusPengajuan.label }}
          </span>
        </div>
        <button
          :class="{
            'hover:bg-[#333333]/5 transition-all duration-300 rounded-full flex items-center justify-center size-[26px]': true,
            'opacity-50 cursor-not-allowed': reasonFormShown,
          }"
          :disabled="reasonFormShown"
          @click="handleCloseModal"
        >
          <span class="k-close text-[34px] text-[#333]" />
        </button>
      </div>

      <div
        v-if="isBahanPacking"
        class="mb-[16px]"
      >
        <div class="flex items-center justify-start flex-wrap gap-[16px]">
          <img
            :src="imagePreview"
            alt="image"
            width="120"
            height="120"
            class="max-w-[120px] max-h-[120px] object-cover rounded-[8px] mb-[16px]"
            @error="handleImageError"
          >
          <div>
            <div class="mb-[8px]">
              <p class="mb-0">
                Nama Bahan Packing
              </p>
              <p
                class="mb-0 font-semibold text-[#333333]"
                :class="{
                  'bg-[#f4f4f4] animate-pulse rounded-[8px] h-[21px]': isLoading,
                }"
              >
                {{ !isLoading ? item.name || '-' : '' }}
              </p>
            </div>
            <div class="mb-[8px]">
              <p class="mb-0">
                Biaya per Satuan
              </p>
              <p
                class="mb-0 font-semibold text-[#333333]"
                :class="{
                  'bg-[#f4f4f4] animate-pulse rounded-[8px] h-[21px]': isLoading,
                }"
              >
                {{ !isLoading ? IDR(item.price) : '' }} {{ chargeType }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="flex items-center justify-between flex-col sm:flex-row gap-[8px] relative mb-[16px]"
      >
        <div
          v-if="isLoading"
          class="bg-[#f4f4f4] animate-pulse rounded-[8px] h-[107.5px] w-full sm:max-w-[220px]"
        />
        <div
          v-else
          class="w-full sm:max-w-[220px] text-[#333333] text-[14px] bg-[#F4F4F4] rounded-[8px] p-[16px]"
        >
          <p class="font-semibold">
            Biaya Sebelumnya
          </p>
          <p class="text-xl">
            {{ IDR(item.previous_cost) }}
          </p>
        </div>
        <span class="k-arrow-right text-[18px] text-[#333]" />
        <div
          :class="`w-full text-[#333333] text-[14px] rounded-[8px] p-[16px] border-[1px] relative ${cardBiayaBaru.css}`"
        >
          <p
            v-if="!isLoading"
            class="font-semibold"
          >
            Biaya Baru yang Diajukan
          </p>
          <p
            v-if="!isLoading"
            class="text-xl mr-[16px]"
          >
            {{ IDR(item.new_cost) }}
          </p>
          <span
            v-if="!isLoading"
            :class="{
              'absolute right-[16px] bottom-[16px] text-[24px] size-[24px] rounded-full text-[#333333]': true,
              'k-arrow-down': item.previous_cost > item.new_cost,
              'k-arrow-up': item.previous_cost < item.new_cost,
            }"
          />
        </div>
      </div>

      <div
        v-if="!isLoading && status === 3"
        class="mb-[24px]"
      >
        <p class="mb-[8px] ml-[16px]">
          Alasan Penolakan
        </p>
        <p
          class="mb-0 text-[#333333] text-[14px] bg-[#F4F4F4] rounded-[8px] p-[16px]"
          :class="{
            'bg-[#f4f4f4] animate-pulse rounded-[8px] h-[21px]': isLoading,
          }"
        >
          {{ !isLoading ? item.reason || '-' : '' }}
        </p>
      </div>

      <div
        v-if="isStatusDiajukan"
        class="text-[#333333] text-[14px] border-dashed border-t-[2px] border-[#f4f4f4] pt-[8px]"
      >
        <p
          class="font-semibold text-center my-[20px]"
          :class="{
            'bg-[#f4f4f4] animate-pulse rounded-[8px] h-[21px]': isLoading,
          }"
        >
          {{ !isLoading ? messageConfirmation : '' }}
        </p>
      </div>
    </div>

    <div
      v-if="isStatusDiajukan"
      class="relative p-[20px] rounded-b-[0.358rem]"
      :class="{'border-t-[1px] bg-[#E31A1A]': reasonFormShown}"
    >
      <div
        v-if="!reasonFormShown"
        class="flex items-center justify-start gap-[8px]"
      >
        <b-button
          variant="primary"
          class="w-full"
          :disabled="isPending"
          @click="handleApprove"
        >
          <b-spinner
            v-if="isPending"
            small
            variant="light"
          />
          Setuju
        </b-button>
        <b-button
          variant="outline-primary"
          class="w-full"
          :disabled="isPending"
          @click="showReasonForm"
        >
          Tolak
        </b-button>
      </div>
      <div
        v-if="reasonFormShown"
        class="w-full"
      >
        <div class="flex items-center justify-between gap-[8px] mb-[16px]">
          <div class="flex items-center justify-start gap-[8px] w-full">
            <button
              class="hover:bg-[#333333]/50 transition-all duration-300 rounded-full flex items-center justify-center"
              @click="hideReasonForm"
            >
              <span class="k-arrow-left-2 text-[18px] text-[#ffffff]" />
            </button>
            <p class="mb-0 text-[#ffffff] text-[14px]">
              Alasan Penolakan
            </p>
          </div>
        </div>
        <b-textarea
          v-model="reason"
          class="w-full mb-[16px]"
          placeholder="Ketik alasan penolakan disini"
        />
        <b-button
          variant="primary"
          class="w-full"
          :disabled="isRejecting"
          @click="handleReject"
        >
          <b-spinner
            v-if="isRejecting"
            small
            variant="light"
          />
          Tolak Pengajuan
        </b-button>
      </div>
    </div>

  </b-modal>
</template>

<script>
import { IDR } from '@/libs/currency'
import { mitraPengajuanStatus, ChargeType, mitraPengajuanIndexByType } from '../config'

/**
 * @description Modal detail pengajuan mitra.
 * @note This modal has 2 mode:
 * - Submission mode: for approval or rejection of bahan packing or tarif change
 * - Detail mode: for view detail of bahan packing or tarif change
 * @note The tarif change can be:
 * - Tarif Penyimpanan
 * - Biaya Jasa Packing
 * - Biaya Print Label
 */
export default {
  name: 'ModalDetailPengajuanMitra',
  data() {
    return {
      item: {
        image_url: '',
      },
      reason: '',
      reasonFormShown: false,
      type: 1,
      status: 1,
      isLoading: true,
      isPending: false,
      isApproving: false,
      isRejecting: false,
    }
  },
  unmounted() {
    this.hideReasonForm()
    this.isLoading = true
  },
  computed: {
    isBahanPacking() {
      return this.type === 'Bahan Packing'
    },
    isStatusDiajukan() {
      return this.status === 1
    },
    imagePreview() {
      if (!this.item.image_url) return 'https://storage.googleapis.com/komerce/assets/svg/default-image.svg'
      return this.item.image_url
    },
    chargeType() {
      if (!this.item.charge_type) return ''
      const parsedChargeType = ChargeType[this.item.charge_type]
      if (!parsedChargeType) return ''
      return `per ${parsedChargeType}`
    },
    messageConfirmation() {
      if (this.isBahanPacking) {
        return 'Apakah Anda ingin menyetujui bahan packing ini?'
      }
      return 'Apakah Anda ingin menyetujui perubahan ini?'
    },
    statusPengajuan() {
      if (this.isLoading) {
        return {
          label: '',
          css: 'bg-[#f4f4f4] animate-pulse rounded-[8px] h-[27px] w-[100px]',
        }
      }
      if (this.status) {
        const parsedStatus = mitraPengajuanStatus[this.status]
        if (!parsedStatus) {
          return {
            label: '-',
            css: '',
          }
        }
        return mitraPengajuanStatus[this.status]
      }
      return {
        label: '-',
        css: '',
      }
    },
    cardBiayaBaru() {
      if (this.isLoading) {
        return {
          label: '',
          css: 'bg-[#f4f4f4] animate-pulse rounded-[8px] h-[107.5px] border-none',
        }
      }
      if (this.status && this.status === 2) {
        return {
          label: 'Diajukan',
          css: 'bg-[#FFF2E2] text-[#AF6A13] border-[#FBA63C]',
        }
      }
      if (this.status) {
        const parsedStatus = mitraPengajuanStatus[this.status]
        if (!parsedStatus) {
          return {
            label: '-',
            css: '',
          }
        }
        return mitraPengajuanStatus[this.status]
      }
      return {
        label: '',
        css: '',
      }
    },
  },
  methods: {
    IDR,
    /**
     * @description Show modal
     * @param item {Object} - Item data that used by modal
     */
    show({ item }) {
      this.type = item.submission_type
      this.status = item.status
      if (item.submission_type === 'Bahan Packing') {
        this.fetchDetailBahanPacking({ id: item.id })
      } else {
        this.fetchDetailTarifChange({ id: item.id })
      }
      this.$refs.mdpm_kompack.show()
    },
    /**
     * @description Close modal and reset data
     */
    handleCloseModal() {
      this.item = {
        image_url: '',
      }
      this.reason = ''
      this.reasonFormShown = false
      this.isLoading = true
      this.$refs.mdpm_kompack.hide()
    },
    /**
     * @description Hide reason form with reset reason
     */
    hideReasonForm() {
      this.reasonFormShown = false
      this.reason = ''
    },
    showReasonForm() {
      this.reasonFormShown = true
    },
    /**
     * @description Handle approve action for bahan packing or tarif change
     */
    handleApprove() {
      this.isApproving = true
      if (this.isBahanPacking) {
        this.mutateBahanPacking({
          id: this.item.id,
          packing_id: this.item.packing_id,
          submissionStatus: 2, // 2 = diterima
          submission_type: this.item.submission_type,
          name: this.item.name,
          price: this.item.price,
          charge_type: this.item.charge_type,
        })
      } else {
        this.mutateTarifChange({
          id: this.item.id,
          submissionStatus: 2, // 2 = diterima
          submission_type: this.item.submission_type,
          service: mitraPengajuanIndexByType[this.type],
          price: this.item.new_cost,
        })
      }
    },
    /**
     * @description Handle reject action for bahan packing or tarif change
     */
    handleReject() {
      this.isRejecting = true
      if (this.isBahanPacking) {
        this.mutateBahanPacking({
          id: this.item.id,
          packing_id: this.item.packing_id,
          submissionStatus: 3, // 3 = ditolak
          submission_type: this.item.submission_type,
          name: this.item.name,
          price: this.item.price,
          charge_type: this.item.charge_type,
          reason: this.reason,
        })
      } else {
        this.mutateTarifChange({
          id: this.item.id,
          submissionStatus: 3, // 3 = ditolak
          service: mitraPengajuanIndexByType[this.type],
          price: this.item.new_cost,
          reason: this.reason,
        })
      }
    },
    /**
     * @description Fetch detail bahan packing for detail mode
     * @param id {string} - Id of the bahan packing
     */
    async fetchDetailBahanPacking({ id }) {
      try {
        const { data } = await this.$http_new.get(`/komship/api/v1/admin/packing-material-submissions/${id}`)
        this.item = data.data
      } catch (error) {
        this.$toast_error({ message: 'Gagal mengambil data bahan packing, silahkan coba lagi' })
      } finally {
        this.isLoading = false
      }
    },
    /**
     * @description Fetch detail tarif change for detail mode. Tarif change can be:
     * - Tarif Penyimpanan
     * - Biaya Jasa Packing
     * - Biaya Print Label
     * @param id {string} - Id of the tarif change
     */
    async fetchDetailTarifChange({ id }) {
      try {
        const { data } = await this.$http_new.get(`/komship/api/v1/admin/warehouse-cost-submissions/${id}`)
        this.item = data.data
      } catch (error) {
        this.$toast_error({ message: 'Gagal mengambil data tarif pengajuan, silahkan coba lagi' })
      } finally {
        this.isLoading = false
      }
    },
    /**
     * @description Mutate bahan packing (for approval or rejection) on submission mode
     * @param id {string} - Id of the bahan packing
     * @param packing_id {string} - Id of the packing
     * @param submissionStatus {number} - Submission status (1 = diajukan, 2 = diterima, 3 = ditolak)
     * @param submission_type {string} - Submission type
     * @param name {string} - Name of the bahan packing
     * @param price {number} - Price of the bahan packing
     * @param charge_type {number} - Charge type of the bahan packing
     * @param reason {string} - Reason of rejection (only required when submission_status is 3)
     */
    async mutateBahanPacking({
      id,
      packing_id,
      submissionStatus,
      submission_type,
      name,
      price,
      charge_type,
      reason, // emptied when submission_status is 2 (Accepted)
    }) {
      this.isPending = true
      try {
        await this.$http_new.put(`/komship/api/v1/admin/packing-material-submissions/${id}`, {
          submission_status: submissionStatus,
          packing_id,
          submission_type,
          name,
          price,
          charge_type,
          reason,
        })
        this.$emit('success')
        if (submissionStatus === 2) {
          this.$toast_success({ message: 'Terima Kasih! Pengajuan Berhasil Disetujui ✅' })
        } else {
          this.$toast_success({ message: 'Pengajuan bahan packing berhasil ditolak' })
        }
        this.handleCloseModal()
      } catch (error) {
        this.$toast_error({ message: 'Maaf, terjadi kesalahan saat menyetujui/menolak pengajuan bahan packing. Silahkan coba lagi nanti.' })
      } finally {
        this.isPending = false
        this.isApproving = false
      }
    },
    /**
     * @description Mutate tarif change (for approval or rejection) on submission mode.
     * Tarif change can be:
     * - Tarif Penyimpanan
     * - Biaya Jasa Packing
     * - Biaya Print Label
     * @param id {string} - Id of the tarif change
     * @param submissionStatus {number} - Submission status (1 = diajukan, 2 = diterima, 3 = ditolak)
     * @param service {number} - Service of the tarif change (1 = Tarif Penyimpanan, 2 = Biaya Jasa Packing, 3 = Biaya Print Label)
     * @param price {number} - New price of the tarif change
     * @param reason {string} - Reason of rejection (only required when submission_status is 3)
     */
    async mutateTarifChange({
      id,
      submissionStatus,
      service,
      price,
      reason,
    }) {
      this.isPending = true
      try {
        await this.$http_new.put(`/komship/api/v1/admin/warehouse-cost-submissions/${id}`, {
          submission_status: submissionStatus,
          id,
          price,
          service,
          reason,
        })
        this.$emit('success')
        if (submissionStatus === 2) {
          this.$toast_success({ message: 'Terima Kasih! Pengajuan Berhasil Disetujui ✅' })
        } else {
          this.$toast_success({ message: 'Pengajuan perubahan biaya berhasil ditolak' })
        }
        this.handleCloseModal()
      } catch (error) {
        this.$toast_error({ message: 'Maaf, terjadi kesalahan saat menyetujui/menolak pengajuan. Silahkan coba lagi nanti.' })
      } finally {
        this.isPending = false
        this.isApproving = false
      }
    },
    handleImageError() {
      this.item.image_url = 'https://storage.googleapis.com/komerce/assets/svg/default-image.svg'
    },
  },
}
</script>
